import { apiHost } from "../api-host";
import { AddOn } from "../pages/home/interfaces";
import { API } from "../path";

export function getAddOnImageSrc(addOnId: AddOn["id"]): string {
  return `${apiHost}${API.ADD_ON}/${addOnId}`;
}
